import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-RequestSizeLimiting',
    templateUrl: './RequestSizeLimiting.component.html'
})
export class RequestSizeLimitingComponent implements OnInit {

    consumerID: string;
    allowed_payload_size = 128;

    data = {
        'consumerID' : this.consumerID,
        'allowed_payload_size' : this.allowed_payload_size,
        'plugin' : 'request-size-limiting'
    };

    constructor() { }

    RequestSizeLimiting() {
    }

    ngOnInit() {
    }

}
